// Per-tab polling interval id shared by fetch/disconnectNotifications
export default { interval: null }



// WEBPACK FOOTER //
// ./src/services/notification/intervalState.js